/**
 * Maps an error from POST /api/v1/link/confirm to an i18n message key.
 * The backend returns HTTP 400 when the code is invalid, expired, or already
 * used; anything else is treated as a transient/unknown failure.
 */
export function linkConfirmErrorKey(error: unknown): string {
  const status = (error as { response?: { status?: number } })?.response?.status;
  if (status === 400) {
    return 'linkAccount.error.invalidCode';
  }
  return 'linkAccount.error.generic';
}
